import { isEmpty } from 'lodash';
import { CustomValidateResolveType } from 'tdesign-react';

import { MissionType } from '@/const/mission';
import { CompletionTipType, GoalType, IMission, IScene, MissionIData } from '@/interface';
import { OperandType, OperatorsType } from '@/interface/numberSysytem';

import { CardData } from '../card/event/customBranch/Branch/numberSystem/cards';
import { ItemCardData } from '../card/event/customBranch/Branch/numberSystem/numberSysytemsSelect';

const validateMissionForm = (
  data: MissionIData & {
    assistantMessageGoal?: string;
    userMessageGoal?: string;
    chatRound?: number;
  },
  _type?: MissionType,
) => {
  let cardInfoJudge = false;
  if (
    data?.name?.trim()
    && data?.image?.url?.url
    && !isEmpty(data?.image?.sample)
  ) {
    cardInfoJudge = true;
  }
  return cardInfoJudge;
};

const validateMissionGoal: (
  data: MissionIData['missionGoal'],
  sceneInfo?: Partial<IScene>
) => CustomValidateResolveType = (data, sceneInfo) => {
  const aiGamePlay = sceneInfo?.aiGamePlay;

  if (data?.goalType === GoalType.GOAL_TYPE_NUM_SYS) {
    if (data?.numSysGoal?.activationCond?.length === 0 || !data?.numSysGoal?.activationCond) {
      return { result: false, message: '请完善数值触发条件', type: 'error' };
    }

    if (aiGamePlay) {
      // 特殊玩法和触发条件的校验，触发条件为特殊玩法的子集
      if (aiGamePlay?.numSys?.isOpen) {
        const conds = validateNumActiveCond(data?.numSysGoal?.activationCond, '数值触发条件', true);
        return conds;
      }
    }


    if (aiGamePlay && !aiGamePlay?.numSys?.isOpen) {
      if (data?.numSysGoal?.activationCond?.length !== 0) {
        return { result: false, message: '幕【AI玩法】中已关闭【数值系统】玩法，请更换为其他触发条件', type: 'error' };
      }
    }

    const conds = validateNumActiveCond(data?.numSysGoal?.activationCond, '数值触发条件', true);
    return conds;
  }


  if (data?.goalType === GoalType.GOAL_TYPE_COUNTDOWN) {
    // 特殊玩法和触发条件的校验，触发条件为特殊玩法的子集
    if (aiGamePlay && !aiGamePlay?.countDown?.isOpen && data?.countDown?.isOpen) {
      return { result: false, message: '幕【AI玩法】中已关闭【倒计时】玩法，请更换为其他触发条件', type: 'error' };
    }
  }

  if (data?.assistantMessageGoal?.text?.trim()
    || data?.userMessageGoal?.text?.trim()
    || data?.chatRound?.round
    || data?.countDown?.isOpen !== undefined
  ) {
    return true;
  }

  return { result: false, message: '获得条件不能为空', type: 'error' };
};

const validateMissionCardForm = (
  data: MissionIData & {
    assistantMessageGoal?: string;
    userMessageGoal?: string;
    chatRound?: number;
  },
  _type?: MissionType,
) => {
  let cardInfoJudge = false;
  if (
    data?.name?.trim()
    && data?.image?.url?.url
    && !isEmpty(data?.image?.sample)
  ) {
    cardInfoJudge = true;
  }
  return cardInfoJudge;
};

const validateTip = (data: MissionIData) => {
  if (data?.completionTip?.tip) {
    if (
      data?.completionTip?.tipType
      === CompletionTipType.COMPLETIONTYPE_MULTIBRANCH
    ) {
      if (
        data?.completionTip?.multiBranch?.filter(item => !item?.optionName || !item?.sceneId)?.length
      ) {
        return false;
      }
    } else {
      return true;
    }
  }
  return false;
};

const validateNumActiveCond: (cond: CardData[], text: string, validateCalculate?: boolean) =>
CustomValidateResolveType = (cond, text, validateCalculate) => {
  if (isEmpty(cond)) {
    return true;
  }
  if (cond.length > 0) {
    const haveCalculate: { result: boolean, message: string }[] = [];

    const isValidate = cond?.every((item) => {
      if (item?.opGroup?.length === 0) {
        return false;
      }
      if (item?.opGroup?.length > 0) {
        if (validateCalculate) {
          haveCalculate.push(validateOpGroupCalculate(item?.opGroup));
        }
        return item?.opGroup?.every((opG) => {
          const constantVal = opG?.operand?.constantVal;
          const variableNumId = opG?.operand?.variableNumId;

          if (opG?.operand?.operandType === OperandType.CONSTANT && (constantVal === undefined)) {
            return false;
          }
          if (opG?.operand?.operandType === OperandType.VARIABLE && (variableNumId === undefined || variableNumId?.trim() === '')) {
            return false;
          }
          return true;
        });
      }
      return true;
    });
    const illegal = validateCalculate ? haveCalculate?.some(e => !e.result) : false;
    if (illegal) {
      return { result: false, message: `${text}配置有误，请检查`, type: 'error' };
    }
    if (!isValidate) {
      return { result: false, message: `请完善${text}`, type: 'error' };
    }
    return true;
  }

  return true;
};

const validateOpGroupCalculate = (cond: ItemCardData[]) => {
  let legitimate = false;
  const illegalOp = [
    OperatorsType.EQ,
    OperatorsType.GT,
    OperatorsType.LT,
    OperatorsType.LTE,
    OperatorsType.GTE,
  ];
  cond?.forEach((e) => {
    if (illegalOp?.includes(e.op)) {
      legitimate = true;
    }
  });
  if (legitimate) {
    return { result: legitimate, message: '' };
  }
  return { result: false, message: '条件配置有误，规则中必须有一条不等式如：等于、大于、小于、大于等于、小于等于' };
};


const validateCompleteTip = (data: IMission['completionTip']) => {
  if (data?.tipType === CompletionTipType.COMPLETIONTYPE_NEXTSCENE) {
    if (data?.nonBranchNumCond?.useOptionCond) {
      const outer = validateNumActiveCond(data?.nonBranchNumCond?.numChange || [], '');
      if (outer !== true) {
        return { result: false, message: '请补充条件/数值系统' };
      }
    }
    return true;
  }

  if (data?.tipType === CompletionTipType.COMPLETIONTYPE_MULTIBRANCH) {
    if (!data?.title?.trim()) {
      return false;
    }

    let correct = true;

    data?.multiBranch?.forEach((e) => {
      if (!correct) {
        return;
      }
      // 验证选项名称
      if (!e?.optionName?.trim()) {
        correct = false;
      }
      // 验证选项条件
      if (e?.useOptionCond) {
        const enter = validateNumActiveCond(e?.optionCond?.activationCond || [], '', true);
        const outer = validateNumActiveCond(e?.optionCond?.numChange || [], '');
        if (enter !== true || outer !== true) {
          correct = false;
        }
      }
    });
    if (correct) {
      return true;
    }
    return { result: false, message: '请补充条件/数值系统' };
  }
  return true;
};


export {
  validateCompleteTip, validateMissionCardForm,
  validateMissionForm,
  validateMissionGoal, validateNumActiveCond, validateOpGroupCalculate, validateTip,
};

